<form [formGroup]="form">
    <mat-form-field appearance="outline"  >
        <mat-label>{{ label|translate}}</mat-label>
        <mat-select disableOptionCentering="true" formControlName="provider" (selectionChange)="onClick()">
            <mat-option value="" selected> {{'Common.Choose'|translate}} </mat-option>
            <mat-option class="theme-select" value="Thuraya">Thuraya</mat-option>
            <mat-option class="theme-select" value="LikeCard">Like Card</mat-option>
            <mat-option class="theme-select" value="OneCard">One Card</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('provider')?.errors?.['required']">
            {{ 'Common.RequiredField' | translate }}
        </mat-error>
    </mat-form-field>
</form>